import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles } from './template.scss';
import { ButtonColors, ButtonFontSizes, ButtonHeights, ButtonTypes } from '../../../ui/gzButton/types';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateIncidentNotesPanel = document.createElement('template');

templateIncidentNotesPanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>

  <div class="notes-list-container">
    <div class="overlay"></div>

    <gz-button
      class="back-btn"
      type="${ButtonTypes.QUIET}"
      color="${ButtonColors.SECONDARY}"
      buttonHeight="${ButtonHeights.SMALL}"
      buttonFontSize="${ButtonFontSizes.SMALL}"
    >
      <gz-icon name="ds-icon-arrow_left_collapse" color="${ButtonColors.SECONDARY}" size="24"></gz-icon>

      <span class="back-btn-text"></span>
    </gz-button>

    <gz-title class="notes-list-title" fontSize="${FontSizes.HEADING_4}"></gz-title>

    <div class="loading-state-container">
      <gz-loader rows="15" columns="2"></gz-loader>
    </div>

    <div class="empty-state-container">
      <gz-image-repo state="start">
        <gz-title
          class="empty-state-title"
          fontWeight="${FontWeights.MEDIUM}"
          fontSize="${FontSizes.HEADING_4}"
        ></gz-title>

        <gz-text class="empty-state-text" fontWeight="100" fontSize="${FontSizes.PARAGRAPH_13}"></gz-text>

        <gz-button class="empty-state-add-note-button"></gz-button>
      </gz-image-repo>
    </div>

    <div class="notes-list hidden">
      <div class="notes-container"></div>

      <div class="add-note-button-container">
        <gz-button class="add-note-button"></gz-button>
      </div>
    </div>

    <div class="note-editor-container"></div>
  </div>
`;
